import { Button, Dialog, DialogActions, DialogTitle, Grid, MenuItem, makeStyles } from '@material-ui/core'
import React, { useState } from 'react'
import { SelectValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { useDispatch } from 'react-redux';
import { MENU_IMPRESION_RECLAMOS_ARRAY } from '../../../../../utils/constants';
import { enviarPDFSolicitudReclamoExterno, imprimirPDFReclamoExterno } from '../../../../../actions/reclamos/reclamosExternosActions';




const useStyles = makeStyles(() => ({
    formControl: {
        marginLeft: 25,
        marginRight: 40,
        minWidth: 50,
        maxWidth: 250,
    },
}));


export const ModalImpresionReclamoExterno = (props) => {
    const { solicitud } = props;
    const dispatch = useDispatch();
    const classes = useStyles();
    const [value, setValue] = useState(1);

    const onSubmitHandler = () => {
        if (value === 1) {
            dispatch(imprimirPDFReclamoExterno(solicitud.id));
        }
        else if (value === 2) {
            dispatch(enviarPDFSolicitudReclamoExterno(solicitud.id));
        }
    }

    return (
        <Dialog
            fullWidth
            maxWidth="sm"
            open={props.open}
            onClose={props.closeModalHandler}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{"Caso N° " + solicitud?.id}</DialogTitle>
            <ValidatorForm onSubmit={onSubmitHandler}>
                <Grid container spacing={2} className={classes.formControl}>
                    <Grid
                        item
                        xs={12}
                        md={6}
                        style={{ display: "flex", justifyContent: "center", gap: "2em" }}
                    >
                        <SelectValidator
                            fullWidth
                            margin="normal"
                            label="Categoría"
                            name="categoriaReclamo"
                            disabled={false}
                            value={value}
                            onChange={(e) => setValue(e.target.value)}
                            InputLabelProps={{ style: { fontWeight: "bold" } }}
                            validators={["required"]}
                            errorMessages={["Este campo es obligatorio"]}
                            style={{ color: "#000" }}
                        >
                            {MENU_IMPRESION_RECLAMOS_ARRAY.map((e) => (
                                <MenuItem key={e.id} value={e.id}>
                                    {e.descripcion}
                                </MenuItem>
                            ))}
                        </SelectValidator>
                    </Grid>
                </Grid>
                <DialogActions>
                    <Button onClick={props.closeModalHandler} color="primary">
                        Cancelar
                    </Button>
                    <Button type="submit" color="primary" autoFocus>
                        Aceptar
                    </Button>
                </DialogActions>
            </ValidatorForm>
        </Dialog>
    )
}
